<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-right>
      <vdr-action-bar-items locationId="order-list" />
      <button class="btn primary mr-1" (click)="reviewPackagesFromOrders()" [disabled]="!selectionManager.selection.length">
        {{ "common.review-packages" | translate }}
      </button>
      <button class="btn mr-1" (click)="export()">
        {{ "common.export" | translate }}
      </button>
      <!-- <button
        class="btn btn-primary"
        type="button"
        style="margin-right: 1rem"
        (click)="exportAllInvoices()"
      >
        {{ "order.export-all-invoices" | translate }}
      </button> -->

      <button class="button primary mr-1" (click)="importFulfillment()">
        {{ "order.import-fulfillment-order" | translate }}
      </button>
      <button
        class="btn btn-primary"
        type="button"
        style="margin-right: 1rem"
        (click)="exportInvoices()"
        [disabled]="selectionManager.selection.length === 0"
      >
        {{ "order.export-invoices" | translate: { count: selectionManager.selection.length } }}
      </button>
      <button
        class="btn btn-primary"
        type="button"
        style="margin-right: 1rem"
        (click)="exportB2BInvoices()"
        [disabled]="!canExportB2B"
      >
        {{ "order.export-b2b-invoices" | translate: { count: selectionManager.selection.length || totalItems } }}
      </button>
      <button
        class="btn btn-primary"
        type="button"
        style="margin-right: 1rem"
        (click)="importRefundOrders()"
      >
        {{ "order.import-refund-orders" | translate }}
      </button>
      <ng-container *ngIf="canCreateDraftOrder">
        <a
          class="btn"
          *vdrIfPermissions="['CreateOrder']"
          [routerLink]="getDraftCreateRoute()"
        >
          <clr-icon shape="plus"></clr-icon>
          {{ "catalog.create-draft-order" | translate }}
        </a>
      </ng-container>
      <vdr-action-bar-dropdown-menu locationId="order-list" />
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>

<vdr-split-view
  [rightPanelOpen]="activeRowId$ | async"
  (closeClicked)="closeContents()"
>
  <ng-template vdrSplitViewLeft>
    <custom-data-table
      class="mt-2"
      id="order-list"
      [items]="items$ | async"
      [itemsPerPage]="itemsPerPage$ | async"
      [totalItems]="totalItems$ | async"
      [currentPage]="currentPage$ | async"
      [filters]="filters"
      [expandedRowIndex]="expandedRowIndex"
      (pageChange)="setPageNumber($event)"
      (itemsPerPageChange)="setItemsPerPage($event)"
    >
      <vdr-bulk-action-menu
        locationId="order-list"
        [hostComponent]="this"
        [selectionManager]="selectionManager"
      ></vdr-bulk-action-menu>
      <vdr-dt2-search
        [searchTermControl]="searchTermControl"
        [searchTermPlaceholder]="'order.search-by-order-code' | translate"
      />

      <expand-div>
        <ng-template let-item="item" let-index="index">
          <order-expand-content [item]="item" [index]="index" />
        </ng-template>
      </expand-div>

      <vdr-dt2-column
        [heading]="'common.id' | translate"
        id="id"
        [hiddenByDefault]="true"
        [sort]="sorts.get('id')"
      >
        <ng-template let-order="item">
          {{ order.id }}
        </ng-template>
      </vdr-dt2-column>
      <vdr-dt2-column
        [heading]="'common.created-at' | translate"
        id="created-at"
        [hiddenByDefault]="true"
      >
        <ng-template let-order="item">
          {{ order.createdAt | localeDate : "short" }}
        </ng-template>
      </vdr-dt2-column>
      <vdr-dt2-column
        [heading]="'common.code' | translate"
        id="code"
        [optional]="false"
      >
        <ng-template let-order="item">
          <a
            class="button-ghost"
            [routerLink]="getOrderDetailRoute(order)"
            ><span>{{ order.code }}</span>
            <clr-icon shape="arrow right"></clr-icon>
          </a>
        </ng-template>
      </vdr-dt2-column>
      <vdr-dt2-column
        [heading]="'order.customer' | translate"
        id="customer"
        [sort]="sorts.get('customerLastName')"
      >
        <ng-template let-order="item">
          <custom-customer-label
            [customer]="order.customer"
            (click)="$event.stopPropagation()"
          ></custom-customer-label>
        </ng-template>
      </vdr-dt2-column>
      <vdr-dt2-column
        [heading]="'order.order-type' | translate"
        id="order-type"
        [hiddenByDefault]="true"
      >
        <ng-template let-order="item">
          <vdr-chip *ngIf="order.type === OrderType.Regular">{{
            "order.order-type-regular" | translate
          }}</vdr-chip>
          <vdr-chip *ngIf="order.type === OrderType.Aggregate">{{
            "order.order-type-aggregate" | translate
          }}</vdr-chip>
          <vdr-chip *ngIf="order.type === OrderType.Seller">{{
            "order.order-type-seller" | translate
          }}</vdr-chip>
        </ng-template>
      </vdr-dt2-column>
      <vdr-dt2-column
        [heading]="'order.state' | translate"
        id="state"
        [sort]="sorts.get('state')"
      >
        <ng-template let-order="item">
          <custom-order-state-label
            [state]="order.state"
          ></custom-order-state-label>
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'order.details' | translate"
        id="view-contents"
        [hiddenByDefault]="false"
      >
        <ng-template let-inbounding="item" let-i="index">
          <button class="button-ghost" (click)="setRowExpand(i)">
            <span>{{ "common.view-contents" | translate }}</span>
            <clr-icon shape="file-group"></clr-icon>
          </button>
        </ng-template>
      </vdr-dt2-column>
      <vdr-dt2-column
        [heading]="'order.total' | translate"
        id="total"
        [sort]="sorts.get('totalWithTax')"
      >
        <ng-template let-order="item">
          <div style="display: flex; flex-direction: column; line-height: 1.35;">
            <span>{{ getOrderTotal(order) }}</span>
            <span
              *ngIf="getConvertedTotal(order) as convertedTotal"
              class="converted-total"
              style="color: var(--color-grey-400, #9e9e9e); font-size: 11px;"
            >
              ≈ {{ convertedTotal }}
            </span>
          </div>
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column [heading]="'order.shipping' | translate" id="shipping">
        <ng-template let-order="item">
          {{ getShippingNames(order) }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column [heading]="'order.quantity' | translate" id="quantity">
        <ng-template let-order="item">
          {{ order.quantity }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column [heading]="'order.quantity-exclude-free-gifts' | translate" id="quantityExcludeFreeGifts">
        <ng-template let-order="item">
          {{ order.quantityExcludeFreeGifts }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'common.updated-at' | translate"
        id="updated-at"
        [hiddenByDefault]="true"
      >
        <ng-template let-order="item">
          {{ order.updatedAt | timeAgo }}
        </ng-template>
      </vdr-dt2-column>
      <vdr-dt2-column
        [heading]="'order.placed-at' | translate"
        id="placed-at"
        [sort]="sorts.get('orderPlacedAt')"
      >
        <ng-template let-order="item">
          {{ getOrderPlacedAt(order) | localeDate : "short" }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'order.payment-method' | translate"
        id="id"
        [hiddenByDefault]="true"
      >
        <ng-template let-order="item">
          {{ paymentMethod(order) }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'common.shipping-country' | translate"
        id="id"
        [hiddenByDefault]="true"
      >
        <ng-template let-order="item">
          {{ shippingCountry(order) }}
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-column
        [heading]="'common.customer-type' | translate"
        id="id"
        [hiddenByDefault]="false"
      >
        <ng-template let-order="item">
          <is-cooperate-column [rowItem]="order.customer"></is-cooperate-column>
        </ng-template>
      </vdr-dt2-column>

      <vdr-dt2-custom-field-column
        *ngFor="let customField of customFields"
        [customField]="customField"
        [sorts]="sorts"
      />
    </custom-data-table>
  </ng-template>
  <ng-template vdrSplitViewRight [splitViewTitle]="'  '">
    <h1>Hello</h1>
    <h1>Hello</h1>
  </ng-template>
</vdr-split-view>
